import { render, staticRenderFns } from "./ResearchOutputClaims.vue?vue&type=template&id=54e9d8e0&scoped=true&"
import script from "./ResearchOutputClaims.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputClaims.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputClaims.vue?vue&type=style&index=0&id=54e9d8e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e9d8e0",
  null
  
)

export default component.exports